
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.267 28.267"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.297 17.36h6.304l1.142 3.774h6.306L16.417 0h-5.88L2.911 21.135h6.245l1.141-3.775zm1.388-7.414c.713-2.557 1.137-4.267 1.449-5.25h.631c.313.983.733 2.666 1.451 5.25l.506 1.648h-4.545l.508-1.648zM.559 24.048h27.15v4.219H.559z"}})])
          )
        }
      }
    